<a
  mat-icon-button
  (click)="toggle()"
  [matTooltip]="
    isBGN
      ? ('global.switchToEuro' | translate)
      : ('global.switchToLev' | translate)
  "
  [matTooltipPosition]="tooltipPosition"
  class="currency-toggle-btn"
  #tooltip="matTooltip"
>
  <mat-icon *ngIf="isBGN" svgIcon="lev"></mat-icon>

  <mat-icon *ngIf="!isBGN">euro</mat-icon>
</a>
